import { render, staticRenderFns } from "./Delivered-Company.vue?vue&type=template&id=f71bf9a4&"
import script from "./Delivered-Company.vue?vue&type=script&lang=js&"
export * from "./Delivered-Company.vue?vue&type=script&lang=js&"
import style0 from "./Delivered-Company.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports